"use client";

import styled from "styled-components";

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;

  .article-detail-mobile-ui-true & {
    display: block;
    margin-bottom: 1.2rem;
  }

  .article-detail-tablet-ui-true & {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 1.2rem;
  }
`;
export const GroupTableWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  width: 100%;
`;

export const GroupTableItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
`;
